
export {ClayButtonWithIcon} from '../../frontend-js-clay-web/__liferay__/exports/@clayui$button.js';
import __x__ from '../../frontend-js-clay-web/__liferay__/exports/@clayui$button.js';export default __x__;